export const getHubBreadcrumbHref = (relativeBaseUrl: string, routePath: string): string => {
	const basePath = relativeBaseUrl.replace(/\/+$/, '');
	if (/^https?:\/\//.test(routePath)) {
		return routePath;
	}
	if (basePath && (routePath === basePath || routePath.startsWith(`${basePath}/`))) {
		return routePath;
	}
	const path = routePath === '/' ? '' : `/${routePath.replace(/^\/+/, '')}`;

	return `${basePath}${path}` || '/';
};
